var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#facebook_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 0c8.837 0 16 7.163 16 16 0 7.986-5.85 14.605-13.5 15.806V20.625h3.729L22.938 16H18.5v-3c0-.237.022-.473.07-.7s.124-.446.23-.647a2.1 2.1 0 0 1 .422-.545 2 2 0 0 1 .4-.283c.377-.204.864-.325 1.485-.325h2.018V6.563s-.458-.079-1.135-.157a22 22 0 0 0-2.447-.156c-3.654 0-6.043 2.215-6.043 6.225V16H9.438v4.625H13.5v11.18C5.85 30.606 0 23.986 0 16 0 7.163 7.163 0 16 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "facebook_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export default SvgFacebook;